import React from 'react';
import { PhotoPrintsGrid } from '../../PhotoPrintsGrid';
import { PhotoPrintDesktop } from '../photo-print/PhotoPrintDesktop';

export const NotEmptyPhotoPrintsGroup = ({ groupId, setDragDisabled }: Props) => (
    <PhotoPrintsGrid groupId={groupId} renderPhoto={id => (
        <PhotoPrintDesktop id={id} setDragDisabledOnGroup={setDragDisabled} />
    )} />
);

type Props = {
    groupId: string;
    setDragDisabled: (value: boolean) => void;
};